/** 활동명 규칙 (docs/SCHEMA.md) */
export const NICKNAME_RULES = {
    /** 영문 기준 최소 글자수 */
    minLatin: 5,
    /** 한글 기준 최소 글자수 */
    minHangul: 2,
    /** 최대 칸수 (한글 1자 = 2칸) */
    maxWidth: 20,
};
/** 지갑주소 최대 길이. 체인별 형식이 달라 길이만 넉넉히 제한한다. */
export const WALLET_ADDRESS_MAX = 120;
/**
 * 지갑주소 형식 검사. 통과하면 trim된 값을 돌려준다.
 * 사내 스테이블코인이 EVM 계열이라 0x 주소는 엄격히(40자리 hex), 그 외 형식은
 * 문자 집합·길이만 본다(체인을 단정하지 않는다). 빈 문자열은 "삭제"로 취급해 여기 오지 않는다.
 */
export function checkWalletAddress(raw) {
    const value = raw.trim();
    if (value.length < 10 || value.length > WALLET_ADDRESS_MAX) {
        return { ok: false, message: '지갑주소 길이를 다시 확인해 주세요.' };
    }
    if (/^0x/i.test(value)) {
        if (!/^0x[0-9a-fA-F]{40}$/.test(value)) {
            return { ok: false, message: '0x로 시작하는 주소는 40자리 16진수여야 해요.' };
        }
        return { ok: true, value };
    }
    if (!/^[A-Za-z0-9._:-]+$/.test(value)) {
        return { ok: false, message: '지갑주소에 쓸 수 없는 문자가 있어요.' };
    }
    return { ok: true, value };
}
/**
 * 활동명 변경 빈도 제한. 관리자는 예외(제한 없음).
 * 거래에 쓰이는 지속 정체성이라 잦은 변경을 막는다.
 */
export const NICKNAME_CHANGE_LIMIT = {
    /** 이 기간(주) 안에 */
    weeks: 15,
    /** 최대 이만큼만 바꿀 수 있다 */
    max: 2,
};
//# sourceMappingURL=user.js.map